import { render, staticRenderFns } from "./newDes.vue?vue&type=template&id=b9fdcede&scoped=true"
import script from "./newDes.vue?vue&type=script&lang=js"
export * from "./newDes.vue?vue&type=script&lang=js"
import style0 from "./newDes.vue?vue&type=style&index=0&id=b9fdcede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fdcede",
  null
  
)

export default component.exports